import { render } from "./Category.vue?vue&type=template&id=145c91fe&scoped=true"
import script from "./Category.vue?vue&type=script&lang=ts"
export * from "./Category.vue?vue&type=script&lang=ts"

import "./Category.vue?vue&type=style&index=0&id=145c91fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-145c91fe"

export default script